import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const HubStationsCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "hub-stations-cell-styled",
})`
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  overflow: hidden;
`;

export const HubStationsCellSummary = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "hub-stations-cell-summary",
})`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HubStationsTooltipList = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "hub-stations-tooltip-list",
})`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const HubStationsTooltipRow = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "hub-stations-tooltip-row",
})`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 420px;
`;

export const HubStationsIdLink = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "hub-stations-id-link",
})`
  color: ${rydeColors.dragBorderColor};
  cursor: pointer;
  text-decoration: underline;
  flex-shrink: 0;
`;
